import { HStack, Image } from '@chakra-ui/react';
import { TableData } from 'Molecules/NestedTable';
import { UserAvatar } from 'Organisms';
import { Typography } from 'Tokens';
import { DatapointSourceEnum } from 'containers/Esrs/pieces/DisclosureRequirements/Requirement';
import { useParams } from 'react-router-dom';
import { useLastEdited } from './LastEdited.hooks';
import { MetricsTableData } from '../../../MetricAnswers.hooks';
import { Tooltip } from 'Atoms';

export const LastEditedBy = ({
  row,
  selectedQuarter,
  metricLevel,
  reportingUnitId,
}: {
  row: TableData<MetricsTableData>;
  selectedQuarter: string;
  metricLevel?: boolean;
  reportingUnitId?: string;
}) => {
  const { esrsAssessmentId } = useParams();
  const lastEdited = useLastEdited(
    esrsAssessmentId ?? '',
    row,
    selectedQuarter,
    metricLevel,
    reportingUnitId
  );
  return lastEdited.user ? (
    <HStack spacing="4px">
      {lastEdited.source === DatapointSourceEnum.moreScope ? (
        <Tooltip label="MoreScope">
          <Image width="20px" src="/assets/moreScope.svg" />
        </Tooltip>
      ) : (
        <UserAvatar user={lastEdited.user} size="xs" />
      )}
      <Typography variant="body">{lastEdited.date}</Typography>
    </HStack>
  ) : (
    <Typography variant="body">—</Typography>
  );
};
